import { createContext, Dispatch, SetStateAction } from 'react';
import noop from 'lodash/noop';

import { Auth, type ForgotPasswordBody, type ResetPasswordBody } from '../helpers/helpers';
import { User } from '../../users/types';

export interface AuthContext {
    setUser: Dispatch<SetStateAction<User[]>>;
    isLoggedIn: boolean;
    session: string;
    logout: () => void;
    login: (params: any) => Promise<any>;
    register: (body: any) => Promise<any>;
    user: Auth['user'];
    currUser: Auth['currUser'];
    localStore: {};
    forgotPassword: (body: ForgotPasswordBody) => Promise<any>;
    openChangePassword: () => Promise<any>;
    resetPassword: (body: ResetPasswordBody) => Promise<any>;
    verifyOtp: (code: string, redirect: string, rememberDevice?: boolean) => Promise<any>;
}

const authContext = createContext<AuthContext>({
    setUser: noop,
    isLoggedIn: false,
    session: '',
    logout: noop,
    verifyOtp: () => Promise.reject(),
    login: () => Promise.reject(),
    register: () => Promise.reject(),
    user: [],
    currUser: null,
    localStore: {},
    forgotPassword: () => Promise.reject(),
    resetPassword: () => Promise.reject(),
    openChangePassword: function (): Promise<any> {
        throw new Error('Function not implemented.');
    }
});
export default authContext;
